import { colors } from './colors';

export const primaryScrollbar = `
  &::-webkit-scrollbar {
      width: 4px !important;
    }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.bg['primary-base']} !important;
    border-radius: 999px !important;
  }

  &::-webkit-scrollbar-track {
    background-color: ${colors.bg['soft-200']} !important;
  }

  &::-webkit-scrollbar-button {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  scrollbar-color: ${colors.bg['primary-base']} ${colors.bg['soft-200']};
  scrollbar-width: thin;
`;
